export enum DistanceBetween {
  wide = 8,
  narrow = 1,
  none = 0,
}
